// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: aukbrhkegRkQ6KizvhdUPT
// Component: cJ8w1eDWyZ
import * as React from "react";

import * as p from "@plasmicapp/react-web";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants,
} from "@plasmicapp/react-web";
import LeftSearchPanel from "../../components/studio/LeftSearchPanel"; // plasmic-import: TqAPn0srTq/component
import ListSectionHeader from "../../components/ListSectionHeader"; // plasmic-import: wNvxk7eOak/component
import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import AddDrawerItem from "../../components/studio/add-drawer/AddDrawerItem"; // plasmic-import: isQPD0RPCw/component
import ListSectionSeparator from "../../components/ListSectionSeparator"; // plasmic-import: uG5_fPM0sK/component

import "@plasmicapp/react-web/lib/plasmic.css";
import defaultcss from "../PP__plasmic__default_style.module.css"; // plasmic-import: global/defaultcss
import projectcss from "../PP__plasmickit_left_pane.module.css"; // plasmic-import: aukbrhkegRkQ6KizvhdUPT/projectcss
import sty from "./PlasmicAddDrawer.module.css"; // plasmic-import: cJ8w1eDWyZ/css

import VariantGroupIcon from "../plasmic_kit/PlasmicIcon__VariantGroup"; // plasmic-import: pyS6pK4Spx-QF/icon
import PlusCirclesvgIcon from "../q_4_icons/icons/PlasmicIcon__PlusCirclesvg"; // plasmic-import: tPPI666-2/icon
import ComponentIcon from "../plasmic_kit/PlasmicIcon__Component"; // plasmic-import: nNWEF4jI3s5DI/icon
import BeforeIcon from "../plasmic_kit/PlasmicIcon__Before"; // plasmic-import: VU26fT14NQttw/icon
import AfterIcon from "../plasmic_kit/PlasmicIcon__After"; // plasmic-import: yzAFS1IyVvChx/icon
import FrameIcon from "../plasmic_kit/PlasmicIcon__Frame"; // plasmic-import: nMkHNFwp_HRuJ/icon
import HStackBlockIcon from "../plasmic_kit/PlasmicIcon__HStackBlock"; // plasmic-import: vrE0GHgUiSGkm/icon
import VStackBlockIcon from "../plasmic_kit/PlasmicIcon__VStackBlock"; // plasmic-import: DTUk351ydDQGv/icon
import TextBlockIcon from "../plasmic_kit/PlasmicIcon__TextBlock"; // plasmic-import: nzc8B7oWFfsYG/icon
import ImageBlockIcon from "../plasmic_kit/PlasmicIcon__ImageBlock"; // plasmic-import: Sta1tgTjp-AlG/icon
import ButtonInputIcon from "../plasmic_kit/PlasmicIcon__ButtonInput"; // plasmic-import: _bmaLjOFc6A0c/icon
import LinkIcon from "../plasmic_kit/PlasmicIcon__Link"; // plasmic-import: BQBWbw0fg66Lw/icon
import PassInputIcon from "../plasmic_kit/PlasmicIcon__PassInput"; // plasmic-import: X561BmD81oKJV/icon
import AreaInputIcon from "../plasmic_kit/PlasmicIcon__AreaInput"; // plasmic-import: BGTwDE0-XM3EQ/icon
import HeadingIcon from "../plasmic_kit/PlasmicIcon__Heading"; // plasmic-import: 52oeoNiO91g3E/icon
import image49X6ZsC5Ww5 from "../plasmic_kit_design_system/images/image4.svg"; // plasmic-import: 9X6ZsC5ww5/picture

export type PlasmicAddDrawer__VariantMembers = {};

export type PlasmicAddDrawer__VariantsArgs = {};
type VariantPropType = keyof PlasmicAddDrawer__VariantsArgs;
export const PlasmicAddDrawer__VariantProps = new Array<VariantPropType>();

export type PlasmicAddDrawer__ArgsType = {};
type ArgPropType = keyof PlasmicAddDrawer__ArgsType;
export const PlasmicAddDrawer__ArgProps = new Array<ArgPropType>();

export type PlasmicAddDrawer__OverridesType = {
  root?: p.Flex<"div">;
  leftSearchPanel?: p.Flex<typeof LeftSearchPanel>;
  content?: p.Flex<"div">;
  prependButton232222222222322?: p.Flex<typeof IconButton>;
  appendButton232222222222322?: p.Flex<typeof IconButton>;
  prependButton2322222222223222?: p.Flex<typeof IconButton>;
  appendButton2322222222223222?: p.Flex<typeof IconButton>;
  prependButton23222222222232222?: p.Flex<typeof IconButton>;
  appendButton23222222222232222?: p.Flex<typeof IconButton>;
  prependButton232222222222322222?: p.Flex<typeof IconButton>;
  appendButton232222222222322222?: p.Flex<typeof IconButton>;
  prependButton23222222222232?: p.Flex<typeof IconButton>;
  appendButton23222222222232?: p.Flex<typeof IconButton>;
  prependButton232222222222?: p.Flex<typeof IconButton>;
  appendButton232222222222?: p.Flex<typeof IconButton>;
  prependButton22?: p.Flex<typeof IconButton>;
  appendButton22?: p.Flex<typeof IconButton>;
};

export interface DefaultAddDrawerProps {
  className?: string;
}

function PlasmicAddDrawer__RenderFunc(props: {
  variants: PlasmicAddDrawer__VariantsArgs;
  args: PlasmicAddDrawer__ArgsType;
  overrides: PlasmicAddDrawer__OverridesType;
  dataFetches?: PlasmicAddDrawer__Fetches;
  forNode?: string;
}) {
  const { variants, args, overrides, forNode, dataFetches } = props;

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(defaultcss.all, projectcss.root_reset, sty.root)}
    >
      <LeftSearchPanel
        data-plasmic-name={"leftSearchPanel"}
        data-plasmic-override={overrides.leftSearchPanel}
        className={classNames("__wab_instance", sty.leftSearchPanel)}
      />

      <div
        data-plasmic-name={"content"}
        data-plasmic-override={overrides.content}
        className={classNames(defaultcss.all, sty.content)}
      >
        <ListSectionHeader
          actions={
            <IconButton
              className={classNames("__wab_instance", sty.iconButton__edwE)}
            >
              <PlusCirclesvgIcon
                className={classNames(defaultcss.all, sty.svg__cv6Ny)}
                role={"img"}
              />
            </IconButton>
          }
          className={classNames("__wab_instance", sty.listSectionHeader__jL8)}
        >
          {"Recently Used..."}
        </ListSectionHeader>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__ufmd0)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton___5Gli)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__hFvRt)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__gOkt)}
          icon={
            <ComponentIcon
              className={classNames(defaultcss.all, sty.svg__dVxk9)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__xTec)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Component 1"}
        </AddDrawerItem>

        <ListSectionSeparator
          className={classNames(
            "__wab_instance",
            sty.listSectionSeparator__shd2
          )}
        />

        <ListSectionHeader
          actions={
            <IconButton
              className={classNames("__wab_instance", sty.iconButton__gwGt)}
            >
              <PlusCirclesvgIcon
                className={classNames(defaultcss.all, sty.svg__cpQ3K)}
                role={"img"}
              />
            </IconButton>
          }
          className={classNames("__wab_instance", sty.listSectionHeader__tPcP)}
        >
          {"Artboards"}
        </ListSectionHeader>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__qmCOn)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__xIblo)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__nBiS7)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem___7GMI)}
          icon={
            <FrameIcon
              className={classNames(defaultcss.all, sty.svg__lHrDq)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__hWsla)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"New artboard"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__rAa1T)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__wvc16)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__hFxp)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__jtA5P)}
          icon={
            <FrameIcon
              className={classNames(defaultcss.all, sty.svg__wc5Vo)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__khVaZ)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"New component"}
        </AddDrawerItem>

        <ListSectionSeparator
          className={classNames(
            "__wab_instance",
            sty.listSectionSeparator__tnazP
          )}
        />

        <ListSectionHeader
          actions={
            <IconButton
              className={classNames("__wab_instance", sty.iconButton__dj1U2)}
            >
              <PlusCirclesvgIcon
                className={classNames(defaultcss.all, sty.svg___6TpUg)}
                role={"img"}
              />
            </IconButton>
          }
          className={classNames("__wab_instance", sty.listSectionHeader__fjgsH)}
        >
          {"Basics"}
        </ListSectionHeader>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__hljV)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__biqL)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__mr3Tg)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem___3UHn)}
          icon={
            <ComponentIcon
              className={classNames(defaultcss.all, sty.svg__h3Co5)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img___2EpwU)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Free box"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__mvhEt)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__fSn7A)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__lsUuS)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__g1BHu)}
          icon={
            <HStackBlockIcon
              className={classNames(defaultcss.all, sty.svg___44ED3)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__yv4GX)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Horizontal stack"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg___7FEuJ)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__nCSai)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__cZdP9)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__ebXz)}
          icon={
            <VStackBlockIcon
              className={classNames(defaultcss.all, sty.svg___9Yq8A)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__cpYaG)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Vertical stack"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__jOfi8)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__auUnh)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__ry53C)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__bciD9)}
          icon={
            <TextBlockIcon
              className={classNames(defaultcss.all, sty.svg__mJisj)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__sU7Hz)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Text"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__oR8N)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__pC6Uv)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__yXdU8)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__mpPMh)}
          icon={
            <ImageBlockIcon
              className={classNames(defaultcss.all, sty.svg__uhDox)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__qyrgv)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Image"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__jYj9D)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__cnN2)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg___4NQy)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__ybvgR)}
          icon={
            <ImageBlockIcon
              className={classNames(defaultcss.all, sty.svg___9RvcA)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__rFqTa)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Icon"}
        </AddDrawerItem>

        <ListSectionSeparator
          className={classNames(
            "__wab_instance",
            sty.listSectionSeparator__axDp
          )}
        />

        <ListSectionHeader
          actions={
            <IconButton
              className={classNames("__wab_instance", sty.iconButton___8P9Bz)}
            >
              <PlusCirclesvgIcon
                className={classNames(defaultcss.all, sty.svg__wD0Jw)}
                role={"img"}
              />
            </IconButton>
          }
          className={classNames("__wab_instance", sty.listSectionHeader__dntNb)}
        >
          {"Project Components"}
        </ListSectionHeader>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg___6MsiS)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__aZjZc)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__fwOgv)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem___03X7)}
          icon={
            <ComponentIcon
              className={classNames(defaultcss.all, sty.svg__mlEo5)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img___2Kt2R)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Component 1"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__tpMtp)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__evXdY)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg___7YOdY)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__e8NG)}
          icon={
            <ComponentIcon
              className={classNames(defaultcss.all, sty.svg__zwEw)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__nqom6)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Component 2"}
        </AddDrawerItem>

        <ListSectionSeparator
          className={classNames(
            "__wab_instance",
            sty.listSectionSeparator___6Uip
          )}
        />

        <ListSectionHeader
          actions={
            <IconButton
              className={classNames("__wab_instance", sty.iconButton__aZWf)}
            >
              <PlusCirclesvgIcon
                className={classNames(defaultcss.all, sty.svg__fq6YP)}
                role={"img"}
              />
            </IconButton>
          }
          className={classNames("__wab_instance", sty.listSectionHeader__mBXq2)}
        >
          {"Unstyled Elements"}
        </ListSectionHeader>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__by05T)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__b4TF)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__yt6S)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__d08Mt)}
          icon={
            <ButtonInputIcon
              className={classNames(defaultcss.all, sty.svg__n2MbN)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__jf5Tn)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Button"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__m3Em1)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__rimuA)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__ukjw)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem___9DKx)}
          icon={
            <LinkIcon
              className={classNames(defaultcss.all, sty.svg__khew5)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__sI4)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Text input"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__diYeR)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__moS4)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__iCrMg)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem___2PtF9)}
          icon={
            <PassInputIcon
              className={classNames(defaultcss.all, sty.svg__uV9ZL)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img___0A4Xc)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Password input"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__as3Uc)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__qJupl)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg___9PSfz)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__pQm3H)}
          icon={
            <AreaInputIcon
              className={classNames(defaultcss.all, sty.svg__h1UgB)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img___5ABvB)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Multiline text input"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__jMu0)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__xnoVz)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__aJ1E6)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__mzba)}
          icon={
            <LinkIcon
              className={classNames(defaultcss.all, sty.svg__lczw)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__rUtn5)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Link"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__vlnmz)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__l4VQp)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg___1Zowh)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__reimP)}
          icon={
            <HeadingIcon
              className={classNames(defaultcss.all, sty.svg__obwhX)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__v9RgC)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Heading"}
        </AddDrawerItem>

        <ListSectionSeparator
          className={classNames(
            "__wab_instance",
            sty.listSectionSeparator___5TREf
          )}
        />

        <ListSectionHeader
          actions={
            <IconButton
              className={classNames("__wab_instance", sty.iconButton__pukfy)}
            >
              <PlusCirclesvgIcon
                className={classNames(defaultcss.all, sty.svg__i66Xp)}
                role={"img"}
              />
            </IconButton>
          }
          className={classNames("__wab_instance", sty.listSectionHeader__lFm1N)}
        >
          {"Icons"}
        </ListSectionHeader>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton>
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__kOet6)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                className={classNames("__wab_instance", sty.iconButton__zw5Ex)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__tvOlh)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem___3FB9B)}
          icon={
            <LinkIcon
              className={classNames(defaultcss.all, sty.svg__gsMUc)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img___3B4ZT)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Link"}
        </AddDrawerItem>

        <ListSectionSeparator
          className={classNames(
            "__wab_instance",
            sty.listSectionSeparator__pHgDl
          )}
        />

        <ListSectionHeader
          actions={
            <IconButton
              className={classNames("__wab_instance", sty.iconButton__odSi4)}
            >
              <PlusCirclesvgIcon
                className={classNames(defaultcss.all, sty.svg__lnIbj)}
                role={"img"}
              />
            </IconButton>
          }
          className={classNames("__wab_instance", sty.listSectionHeader__xEmQc)}
        >
          {"Images"}
        </ListSectionHeader>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton
                data-plasmic-name={"prependButton232222222222322"}
                data-plasmic-override={overrides.prependButton232222222222322}
              >
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__kkZrF)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                data-plasmic-name={"appendButton232222222222322"}
                data-plasmic-override={overrides.appendButton232222222222322}
                className={classNames(
                  "__wab_instance",
                  sty.appendButton232222222222322
                )}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__tfSww)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__aItZi)}
          icon={
            <LinkIcon
              className={classNames(defaultcss.all, sty.svg___3GI21)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__gKhIs)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Link"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton
                data-plasmic-name={"prependButton2322222222223222"}
                data-plasmic-override={overrides.prependButton2322222222223222}
              >
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__icLPl)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                data-plasmic-name={"appendButton2322222222223222"}
                data-plasmic-override={overrides.appendButton2322222222223222}
                className={classNames(
                  "__wab_instance",
                  sty.appendButton2322222222223222
                )}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__oCx)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem___9WRqQ)}
          icon={
            <LinkIcon
              className={classNames(defaultcss.all, sty.svg___1ClMz)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__mJt6E)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Link"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton
                data-plasmic-name={"prependButton23222222222232222"}
                data-plasmic-override={overrides.prependButton23222222222232222}
              >
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__eJtMs)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                data-plasmic-name={"appendButton23222222222232222"}
                data-plasmic-override={overrides.appendButton23222222222232222}
                className={classNames(
                  "__wab_instance",
                  sty.appendButton23222222222232222
                )}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__ey6L0)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__gu03X)}
          icon={
            <LinkIcon
              className={classNames(defaultcss.all, sty.svg__xQTs)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__gxhnB)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Link"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton
                data-plasmic-name={"prependButton232222222222322222"}
                data-plasmic-override={
                  overrides.prependButton232222222222322222
                }
              >
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__wQjvn)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                data-plasmic-name={"appendButton232222222222322222"}
                data-plasmic-override={overrides.appendButton232222222222322222}
                className={classNames(
                  "__wab_instance",
                  sty.appendButton232222222222322222
                )}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__sUnZ)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__wMAol)}
          icon={
            <LinkIcon
              className={classNames(defaultcss.all, sty.svg___2AppX)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__bmZrC)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Link"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton
                data-plasmic-name={"prependButton23222222222232"}
                data-plasmic-override={overrides.prependButton23222222222232}
              >
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__z48Ym)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                data-plasmic-name={"appendButton23222222222232"}
                data-plasmic-override={overrides.appendButton23222222222232}
                className={classNames(
                  "__wab_instance",
                  sty.appendButton23222222222232
                )}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__l8Ht9)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__zeOZs)}
          icon={
            <LinkIcon
              className={classNames(defaultcss.all, sty.svg__bb0Oo)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__aGtDa)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Whatevs"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton
                data-plasmic-name={"prependButton232222222222"}
                data-plasmic-override={overrides.prependButton232222222222}
              >
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__p5CWf)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                data-plasmic-name={"appendButton232222222222"}
                data-plasmic-override={overrides.appendButton232222222222}
                className={classNames(
                  "__wab_instance",
                  sty.appendButton232222222222
                )}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__dghs7)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__aw21I)}
          icon={
            <LinkIcon
              className={classNames(defaultcss.all, sty.svg___5BeZm)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__oUhu)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Link"}
        </AddDrawerItem>

        <AddDrawerItem
          actions={
            <React.Fragment>
              <IconButton
                data-plasmic-name={"prependButton22"}
                data-plasmic-override={overrides.prependButton22}
              >
                <BeforeIcon
                  className={classNames(defaultcss.all, sty.svg__mHwI6)}
                  role={"img"}
                />
              </IconButton>

              <IconButton
                data-plasmic-name={"appendButton22"}
                data-plasmic-override={overrides.appendButton22}
                className={classNames("__wab_instance", sty.appendButton22)}
              >
                <AfterIcon
                  className={classNames(defaultcss.all, sty.svg__jTFvr)}
                  role={"img"}
                />
              </IconButton>
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.addDrawerItem__gx59S)}
          icon={
            <LinkIcon
              className={classNames(defaultcss.all, sty.svg__c1VUw)}
              role={"img"}
            />
          }
          previewImage={
            <img
              alt={""}
              className={classNames(defaultcss.img, sty.img__bdrO6)}
              src={image49X6ZsC5Ww5}
            />
          }
        >
          {"Link"}
        </AddDrawerItem>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "leftSearchPanel",
    "content",
    "prependButton232222222222322",
    "appendButton232222222222322",
    "prependButton2322222222223222",
    "appendButton2322222222223222",
    "prependButton23222222222232222",
    "appendButton23222222222232222",
    "prependButton232222222222322222",
    "appendButton232222222222322222",
    "prependButton23222222222232",
    "appendButton23222222222232",
    "prependButton232222222222",
    "appendButton232222222222",
    "prependButton22",
    "appendButton22",
  ],
  leftSearchPanel: ["leftSearchPanel"],
  content: [
    "content",
    "prependButton232222222222322",
    "appendButton232222222222322",
    "prependButton2322222222223222",
    "appendButton2322222222223222",
    "prependButton23222222222232222",
    "appendButton23222222222232222",
    "prependButton232222222222322222",
    "appendButton232222222222322222",
    "prependButton23222222222232",
    "appendButton23222222222232",
    "prependButton232222222222",
    "appendButton232222222222",
    "prependButton22",
    "appendButton22",
  ],
  prependButton232222222222322: ["prependButton232222222222322"],
  appendButton232222222222322: ["appendButton232222222222322"],
  prependButton2322222222223222: ["prependButton2322222222223222"],
  appendButton2322222222223222: ["appendButton2322222222223222"],
  prependButton23222222222232222: ["prependButton23222222222232222"],
  appendButton23222222222232222: ["appendButton23222222222232222"],
  prependButton232222222222322222: ["prependButton232222222222322222"],
  appendButton232222222222322222: ["appendButton232222222222322222"],
  prependButton23222222222232: ["prependButton23222222222232"],
  appendButton23222222222232: ["appendButton23222222222232"],
  prependButton232222222222: ["prependButton232222222222"],
  appendButton232222222222: ["appendButton232222222222"],
  prependButton22: ["prependButton22"],
  appendButton22: ["appendButton22"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  leftSearchPanel: typeof LeftSearchPanel;
  content: "div";
  prependButton232222222222322: typeof IconButton;
  appendButton232222222222322: typeof IconButton;
  prependButton2322222222223222: typeof IconButton;
  appendButton2322222222223222: typeof IconButton;
  prependButton23222222222232222: typeof IconButton;
  appendButton23222222222232222: typeof IconButton;
  prependButton232222222222322222: typeof IconButton;
  appendButton232222222222322222: typeof IconButton;
  prependButton23222222222232: typeof IconButton;
  appendButton23222222222232: typeof IconButton;
  prependButton232222222222: typeof IconButton;
  appendButton232222222222: typeof IconButton;
  prependButton22: typeof IconButton;
  appendButton22: typeof IconButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAddDrawer__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> = {
  // Explicitly specify variants, args, and overrides as objects
  variants?: PlasmicAddDrawer__VariantsArgs;
  args?: PlasmicAddDrawer__ArgsType;
  overrides?: NodeOverridesType<T>;
  dataFetches?: PlasmicAddDrawer__Fetches;
} & Omit<PlasmicAddDrawer__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
  // Specify args directly as props
  Omit<PlasmicAddDrawer__ArgsType, ReservedPropsType> &
  // Specify overrides for each element directly as props
  Omit<
    NodeOverridesType<T>,
    ReservedPropsType | VariantPropType | ArgPropType
  > &
  // Specify props for the root element
  Omit<
    Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
    ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
  >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicAddDrawer__ArgProps,
      internalVariantPropNames: PlasmicAddDrawer__VariantProps,
    });

    const { dataFetches } = props;

    return PlasmicAddDrawer__RenderFunc({
      variants,
      args,
      overrides,
      dataFetches,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAddDrawer";
  } else {
    func.displayName = `PlasmicAddDrawer.${nodeName}`;
  }
  return func;
}

export const PlasmicAddDrawer = Object.assign(
  // Top-level PlasmicAddDrawer renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    leftSearchPanel: makeNodeComponent("leftSearchPanel"),
    content: makeNodeComponent("content"),
    prependButton232222222222322: makeNodeComponent(
      "prependButton232222222222322"
    ),
    appendButton232222222222322: makeNodeComponent(
      "appendButton232222222222322"
    ),
    prependButton2322222222223222: makeNodeComponent(
      "prependButton2322222222223222"
    ),
    appendButton2322222222223222: makeNodeComponent(
      "appendButton2322222222223222"
    ),
    prependButton23222222222232222: makeNodeComponent(
      "prependButton23222222222232222"
    ),
    appendButton23222222222232222: makeNodeComponent(
      "appendButton23222222222232222"
    ),
    prependButton232222222222322222: makeNodeComponent(
      "prependButton232222222222322222"
    ),
    appendButton232222222222322222: makeNodeComponent(
      "appendButton232222222222322222"
    ),
    prependButton23222222222232: makeNodeComponent(
      "prependButton23222222222232"
    ),
    appendButton23222222222232: makeNodeComponent("appendButton23222222222232"),
    prependButton232222222222: makeNodeComponent("prependButton232222222222"),
    appendButton232222222222: makeNodeComponent("appendButton232222222222"),
    prependButton22: makeNodeComponent("prependButton22"),
    appendButton22: makeNodeComponent("appendButton22"),

    // Metadata about props expected for PlasmicAddDrawer
    internalVariantProps: PlasmicAddDrawer__VariantProps,
    internalArgProps: PlasmicAddDrawer__ArgProps,
  }
);

export default PlasmicAddDrawer;
/* prettier-ignore-end */
